import { Button, type ButtonProps, Icon, Tooltip } from '@chakra-ui/react';
import { VideoRecorder } from '@kula-ai/icons/solid/VideoRecorder';
import { useEffect, useState } from 'react';
import { type InterviewType } from '../types/interview';
import { EXTERNAL_MEETING_LOCATION } from '@/ui-library/components/constants';

interface JoinInterviewButtonProps {
  interview: InterviewType;
  props?: ButtonProps;
}

export const JoinInterviewButton = ({
  interview,
  props,
}: JoinInterviewButtonProps) => {
  const { meeting_link, start_time, location } = interview;

  const meetingLink =
    meeting_link ||
    (EXTERNAL_MEETING_LOCATION.includes(location) &&
      interview?.[`${location}_interview`]?.ext_interview_meeting_link);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  // Enable button only before 10 minutes of interview
  useEffect(() => {
    const interviewStartTime = new Date(start_time).getTime();
    const now = Date.now();
    const startsInMinutes = (interviewStartTime - now) / 60000;

    // If the interview starts in more than 60 minutes, don't add setInterval
    if (startsInMinutes > 60) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- pre-existing; behavior preserved (extraction move)
      setIsButtonEnabled(false);
      return;
    }

    const checkTime = () => {
      const currentTime = Date.now();
      const timeToStart = (interviewStartTime - currentTime) / 60000;
      setIsButtonEnabled(timeToStart <= 10 && timeToStart > -60);
    };

    checkTime();

    const interval = setInterval(checkTime, 60000);

    return () => clearInterval(interval);
  }, [start_time]);

  return (
    <Tooltip
      label={
        !isButtonEnabled
          ? 'You’ll be able to join the interview 10 minutes before it starts'
          : ''
      }
      hasArrow
      shouldWrapChildren
    >
      <Button
        variant="primary"
        onClick={() => {
          window.open(meetingLink, '_blank');
        }}
        disabled={!isButtonEnabled}
        {...props}
      >
        <Icon width="16px" height="16px" mr="5px" as={VideoRecorder} />
        Join interview
      </Button>
    </Tooltip>
  );
};
